import { render, staticRenderFns } from "./LpuList.vue?vue&type=template&id=6649011a"
import script from "./LpuList.vue?vue&type=script&lang=js"
export * from "./LpuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports